import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardMedia,
  IconButton,
  Modal,
  Chip,
  Stack
} from '@mui/material';
import { 
  ChevronLeft, 
  ChevronRight, 
  Close, 
  Favorite, 
  Share,
  PlayCircle,
  Videocam 
} from '@mui/icons-material';
import { investorApi } from '../../api/api';
import { useSelector } from 'react-redux';
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useDispatch } from "react-redux";
import { toggleFavorite } from '../../redux/reducers/favoritesSlice';
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShareProperty from '../common/shareProperty';
import LoginModal from '../common/LoginModal';
import { useLocation,useParams } from 'react-router-dom';

const VillaImage = ({ propertyId, propertyType, property_refferal_code }) => {
  const { userId, isAuthenticated, user_refferal_code } = useSelector((state) => state.user);
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [allMedia, setAllMedia] = useState([]); // Combined images and videos
  const dispatch = useDispatch();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentMediaType, setCurrentMediaType] = useState('image');
  const [openModal, setOpenModal] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const theme = useSelector((data) => data.themeValue.colors);
  const isMobile = window.innerWidth <= 600;
  const favoriteItems = useSelector((state) => state.favorites.items);
  const [showPopup, setShowPopup] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const location = useLocation();

    const { slug } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const referralCode = queryParams.get("ref");

// let propertyId = null;

// if (slug) {
//   const parts = slug.split("-");
//   propertyId = parts[parts.length - 1]; 
// }

  // Fetch images
  useEffect(() => {
    if (!propertyId) return;

    const fetchImages = async () => {
      try {
        const response = await investorApi.getImagesByPropertyId(propertyId);
        const imageData = response.data || [];
        setImages(imageData);
        
        // Initialize with images
        const mediaWithType = imageData.map(img => ({
          type: 'image',
          url: img.ImageURL,
          id: img.id
        }));
        setAllMedia(mediaWithType);
      } catch (error) {
        console.error('Failed to fetch images:', error);
      }
    };

    fetchImages();
  }, [propertyId]);

  // Fetch videos
  useEffect(() => {
    if (!propertyId) return;

    const fetchVideos = async () => {
      const setdata = {
        type: propertyType || 2,
        reference_id: propertyId,
      };

      try {
        const response = await investorApi.getPropertyVideos(setdata);

        
        if (response.data && Array.isArray(response.data.data)) {
          const videoData = response.data.data.map(video => ({
            type: 'video',
            url: video.video_url,
            id: video.id
          }));
          setVideos(videoData);
          
          // Add videos to the beginning
          setAllMedia(prev => {
            return videoData.concat(prev);
          });
        }
      } catch (error) {
        console.error("Error fetching property videos:", error);
      }
    };
    
    fetchVideos();
  }, [propertyId, propertyType]);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % allMedia.length);
    setCurrentMediaType(allMedia[(currentImageIndex + 1) % allMedia.length]?.type || 'image');
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + allMedia.length) % allMedia.length);
    setCurrentMediaType(allMedia[(currentImageIndex - 1 + allMedia.length) % allMedia.length]?.type || 'image');
  };

  const handleOpenModal = (index) => {
    setCurrentImageIndex(index);
    setCurrentMediaType(allMedia[index]?.type || 'image');
    setOpenModal(true);
  };

   const getShareUrl = (property) => {
  const baseUrl = window.location.origin;

  let path = `villa/${slug}`; 

  if (user_refferal_code) {
    path += `?ref=${user_refferal_code}`;
  }

  return `${baseUrl}/${path}`;
};
  

  const handleCloseModal = () => setOpenModal(false);

  // Helper to generate unique ID from property object
  const getUniqueId = ({ id, type }) => {
    const typeMap = {
      1: 'project',
      2: 'property',
      3: 'apartment',
      4: 'villa',
    };
    const typeLabel = typeMap[type] || 'villa';
    return `${typeLabel}_${id}`;
  };

  // Toggle like for a full property object
  const toggleLike = (property) => {
    const uniqueId = getUniqueId(property);
    dispatch(toggleFavorite(uniqueId));
  };

  // Check like status for a full property object
  const isLiked = (property) => {
    const uniqueId = getUniqueId(property);
    return favoriteItems.includes(uniqueId);
  };

  // Render media item
  const renderMedia = (media, index, showActions = false) => {
    if (!media) return null;
    
    const isVideo = media.type === 'video';
    const CardContent = isVideo ? (
      <>
        <Box
          component="video"
          src={media.url}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.3)',
          }}
        >
          <PlayCircle 
            sx={{ 
              fontSize: 60, 
              color: 'white',
              cursor: 'pointer'
            }} 
          />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            left: 8,
            backgroundColor: 'rgba(0,0,0,0.7)',
            color: 'white',
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}
        >
          <Videocam fontSize="small" />
          VIDEO
        </Box>
      </>
    ) : (
      <CardMedia
        component="img"
        image={media.url}
        alt="Property Image"
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
    );

    return (
      <Card 
        sx={{ 
          height: '100%', 
          borderRadius: 0,
          position: 'relative',
          overflow: 'hidden',
          cursor: 'pointer',
          transition: 'transform 0.5s ease',
          '&:hover': {
            transform: 'scale(1.03)'
          }
        }}
        onClick={() => handleOpenModal(index)}
      >
        {CardContent}
        {showActions && (
          <Box sx={{ 
            position: 'absolute', 
            top: 8, 
            right: 8, 
            display: 'flex', 
            gap: 1,
            zIndex: 2
          }}>
            <IconButton
              sx={{
                backgroundColor: "#F5F5F5",
                boxShadow: 2,
                borderRadius: "50%",
                width: "45px",
                height: "45px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (!isAuthenticated) {
                  setShowLoginModal(true);
                  return;
                }
                toggleLike({ id: propertyId, type: propertyType });
              }}
              title="Like"
            >
              {isLiked({ id: propertyId, type: propertyType }) ? (
                <FavoriteIcon style={{ color: 'red' }} />
              ) : (
                <FavoriteBorderIcon style={{ color: theme.normal_icon }} />
              )}
            </IconButton>
            <IconButton
              sx={{
                backgroundColor: theme.background,
                boxShadow: 2,
                borderRadius: "50%",
                width: "45px",
                height: "45px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (!isAuthenticated) {
                  setShowLoginModal(true);
                  return;
                }
                setShowPopup(true);
              }}
            >
              <Share sx={{ color: theme.normal_icon }} />
            </IconButton>
          </Box>
        )}
      </Card>
    );
  };

  if (allMedia.length === 0) return null;

  return (
    <Box sx={{
      width: '100%',
      maxWidth: '1300px',
      margin: '0 auto',
      position: 'relative',
      borderRadius: 2,
      overflow: 'hidden',
    }}>
      <Box sx={{
        display: 'flex',
        gap: 1,
        height: isMobile ? 'auto' : '80vh'
      }}>
        {/* Primary media (first item) */}
        <Box sx={{
          width: "50%",
          height: isMobile ? '50vh' : '100%',
          position: 'relative',
          borderRadius: 1,
          overflow: 'hidden'
        }}>
          {allMedia[0] && renderMedia(allMedia[0], 0)}
        </Box>

        {/* Secondary media */}
        <Box sx={{
          width: "50%",
          height: isMobile ? '50vh' : '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 1
        }}>
          {/* Second media item (with actions) */}
          <Box sx={{ 
            width: '100%', 
            height: '50%', 
            position: 'relative', 
            borderRadius: 1, 
            overflow: 'hidden' 
          }}>
            {allMedia[1] && renderMedia(allMedia[1], 1, true)}
          </Box>

          {/* Third media item */}
          <Box sx={{ 
            width: '100%', 
            height: '50%', 
            position: 'relative', 
            borderRadius: 1, 
            overflow: 'hidden' 
          }}>
            {allMedia[2] && renderMedia(allMedia[2], 2)}
          </Box>
        </Box>
      </Box>

      {showPopup && (
        <Box sx={styles.modal}>
          <ShareProperty
            property={propertyId}
            getShareUrl={getShareUrl}
            onClose={() => setShowPopup(false)}
          />
        </Box>
      )}

      {showLoginModal && (
        <LoginModal onClose={() => setShowLoginModal(false)} />
      )}

      {/* Fullscreen Modal */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(4px)'
        }}
      >
        <Box sx={{
          width: '95vw',
          height: '95vh',
          bgcolor: 'rgba(0, 0, 0, 0.95)',
          borderRadius: 4,
          overflow: 'hidden',
          position: 'relative',
        }}>
          <IconButton
            onClick={handleCloseModal}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              zIndex: 1,
              backgroundColor: 'rgba(0,0,0,0.5)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.8)'
              }
            }}
          >
            <Close />
          </IconButton>

          <Box sx={{ 
            width: '100%', 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            position: 'relative' 
          }}>
            <Box sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {allMedia[currentImageIndex] && (
                currentMediaType === 'image' ? (
                  <CardMedia
                    component="img"
                    image={allMedia[currentImageIndex].url}
                    alt="Property Image"
                    sx={{
                      objectFit: 'contain',
                      width: '100%',
                      height: '100%',
                      maxHeight: 'calc(95vh - 80px)'
                    }}
                  />
                ) : (
                  <Box
                    component="video"
                    src={allMedia[currentImageIndex].url}
                    controls
                    autoPlay
                    sx={{
                      width: '90%',
                      maxHeight: 'calc(95vh - 80px)',
                      borderRadius: '4px'
                    }}
                  />
                )
              )}
              <IconButton
                onClick={prevImage}
                sx={{
                  position: 'absolute',
                  left: 16,
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.3)'
                  }
                }}
              >
                <ChevronLeft fontSize="large" />
              </IconButton>
              <IconButton
                onClick={nextImage}
                sx={{
                  position: 'absolute',
                  right: 16,
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.3)'
                  }
                }}
              >
                <ChevronRight fontSize="large" />
              </IconButton>
            </Box>

            <Box sx={{
              p: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              gap: 1
            }}>
              <Stack direction="row" spacing={1}>
                <Chip
                  label={`${currentImageIndex + 1} / ${allMedia.length}`}
                  sx={{ 
                    backgroundColor: 'rgba(255,255,255,0.2)', 
                    color: 'white' 
                  }}
                />
                {allMedia[currentImageIndex]?.type === 'video' && (
                  <Chip
                    icon={<Videocam />}
                    label="Video"
                    sx={{ 
                      backgroundColor: 'rgba(255,255,255,0.2)', 
                      color: 'white' 
                    }}
                  />
                )}
              </Stack>
              {/* Thumbnail navigation */}
              {allMedia.length > 1 && (
                <Box sx={{
                  display: 'flex',
                  gap: 1,
                  overflowX: 'auto',
                  maxWidth: '100%',
                  padding: '0 10px',
                  '&::-webkit-scrollbar': { display: 'none' }
                }}>
                  {allMedia.map((media, index) => (
                    <Box
                      key={index}
                      onClick={() => {
                        setCurrentImageIndex(index);
                        setCurrentMediaType(media.type);
                      }}
                      sx={{
                        width: 60,
                        height: 40,
                        minWidth: 60,
                        borderRadius: 1,
                        overflow: 'hidden',
                        cursor: 'pointer',
                        position: 'relative',
                        border: currentImageIndex === index ? '2px solid white' : 'none',
                        opacity: currentImageIndex === index ? 1 : 0.7,
                        transition: 'all 0.3s',
                        '&:hover': {
                          opacity: 1,
                          transform: 'scale(1.05)'
                        }
                      }}
                    >
                      {media.type === 'image' ? (
                        <CardMedia
                          component="img"
                          image={media.url}
                          sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ) : (
                        <>
                          <Box
                            component="video"
                            src={media.url}
                            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                          <PlayCircle
                            sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              color: 'white',
                              fontSize: 16
                            }}
                          />
                        </>
                      )}
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

const styles = {
  modal: {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "12px",
    width: "90%",
    maxWidth: "450px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    animation: "fadeIn 0.3s ease-out",
    "& h2": {
      fontSize: "1.5rem",
      marginBottom: "1rem",
      color: "#333",
    },
    "& p": {
      marginBottom: "1.5rem",
      color: "#666",
    }
  },
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "translateY(-20px)" },
    to: { opacity: 1, transform: "translateY(0)" }
  }
};

export default VillaImage;